module.exports = __webpack_public_path__ + "img/xtgl.b7b56b8d.png";